export function currencyFormatter(value: number): string {
    if (!Number(value)) return ''

    const amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(value / 100)

    return `${amount}`
}

export function formatAmountForDisplay(
    amount: number,
    currency: string
): string {
    let numberFormat = new Intl.NumberFormat(['en-US'], {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
    })
    return numberFormat.format(amount)
}

export function formatToCents(amount: number, currency: string): number {
    let numberFormat = new Intl.NumberFormat(['en-US'], {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
    })
    const parts = numberFormat.formatToParts(amount)
    let zeroDecimalCurrency: boolean = true
    for (let part of parts) {
        if (part.type === 'decimal') {
            zeroDecimalCurrency = false
        }
    }
    return zeroDecimalCurrency ? amount : Math.round(amount * 100)
}

export function formatAmountFromStripe(amount: number): string {
    return (amount / 100).toFixed(2)
}
